const CLIPBOARD_CLEAR_DELAY_MS = 60_000;

export type ClipboardClearResult = "cleared" | "changed" | "unavailable";

export async function clearClipboardIfStillMatches(value: string): Promise<ClipboardClearResult> {
  const clipboard = navigator.clipboard;
  if (!clipboard?.readText || !clipboard?.writeText) return "unavailable";

  try {
    if (await clipboard.readText() !== value) return "changed";
    await clipboard.writeText("");
    return "cleared";
  } catch {
    return "unavailable";
  }
}

export function scheduleClipboardClear(value: string, onUnavailable: () => void): number {
  return window.setTimeout(() => {
    void clearClipboardIfStillMatches(value).then((result) => {
      if (result === "unavailable") onUnavailable();
    });
  }, CLIPBOARD_CLEAR_DELAY_MS);
}
